import React from "react";
import { Button, Col } from "react-bootstrap";

// Contants
const baseURL = process.env.REACT_APP_API;

/**
 * Componente FilePreview para mostrar una vista previa de archivos.
 * Soporta imágenes, videos, audios y otros tipos de archivos.
 *
 * @param {Object} file - El archivo a mostrar.
 *
 * @returns {JSX.Element} - Elemento JSX de la vista previa.
 */
const FilePreview = ({ file }) => {
  // Definición de los renderizadores para cada tipo de archivo.
  const fileTypes = {
    image: (url) => (
      <img src={url} alt="file" height={250} className="rounded" />
    ),
    video: (url) => (
      <video src={url} controls height={250} className="rounded" />
    ),
    audio: (url) => (
      <audio
        src={url}
        controls
        height={250}
        className="rounded border border-secondary rounded-pill"
      />
    ),
    file: (fileName) => (
      <div className="d-flex justify-content-center align-items-center h-100">
        <i className="uil uil-file h1" />
        <span className="ms-2">{fileName}</span>
      </div>
    ),
  };

  /**
   * Renderiza la vista previa del archivo.
   *
   * @param {string} type - El tipo de archivo.
   * @param {string} url - La URL del archivo.
   * @param {string} fileName - El nombre del archivo.
   * @returns {JSX.Element} - Elemento JSX de la vista previa.
   */
  const renderPreview = (type, url, fileName = "") => {
    const renderFunction = fileTypes[type] || fileTypes["file"];
    return renderFunction(url, fileName);
  };

  // Determina qué contenido mostrar basado en el tipo de archivo
  let content;
  if (typeof file === "string") {
    // En caso de que sea una imagen de una respuesta rápida
    content = renderPreview("image", `${baseURL}/${file}`);
  } else if (file instanceof File) {
    // Si el archivo es una instancia de File, se crea una URL temporal y se determina el tipo
    const url = URL.createObjectURL(file);
    const fileType = file.type.split("/")[0];
    content = renderPreview(fileType, url, file.name);
  }

  return content ? (
    <div className="d-flex align-items-center py-1 ">
      <Col xl={12} className="d-flex justify-content-center">
        {content}
      </Col>
    </div>
  ) : null;
};

export default FilePreview;
